
import MainRoutes from "./Routes/MainRoutes";

import { HelmetProvider } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { SnackbarProvider } from "notistack";
// ..
AOS.init();


function App() {
  return (

    <>
      <HelmetProvider>
        <SnackbarProvider>
          <MainRoutes />
        </SnackbarProvider>
      </HelmetProvider>
    </>

  );
}

export default App;
